"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteTeam = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var CensusCollector_1 = require("Onboarding/CensusCollector/CensusCollector");
var classnames_1 = __importDefault(require("classnames"));
var react_transition_group_1 = require("react-transition-group");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var Utils_1 = require("Utils/Utils");
var c = (0, BemBuilder_1.default)("invite-team-form");
var FormV2FieldTransition = function (_a) {
    var className = _a.className, children = _a.children;
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: true, appear: true, enter: false, exit: false, timeout: 1700, classNames: c("field-transition") },
        react_1.default.createElement("div", { className: className }, children)));
};
var INVITE_EMAIL_PLACEHOLDERS = ["john@example.com", "jane@example.com", "hannah@example.com"];
var EMAIL_FIELD_BASE_ID = "invite-user";
var InviteTeam = function (props) {
    var _a = __read((0, react_1.useState)("Continue"), 2), buttonText = _a[0], setButtonText = _a[1];
    var onFieldChange = function (newValues) {
        var invitees = Object.values(newValues).filter(function (x) { return x; }).length;
        if (invitees > 0) {
            setButtonText("Send Invites ");
        }
        else {
            setButtonText("Continue");
        }
        props.dataStore.update(newValues);
        props.spheresBackgroundManager.triggerPulse(1.5);
    };
    var submitForm = function (payload) { return __awaiter(void 0, void 0, Promise, function () {
        var emails, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    emails = Object.values(payload).filter(function (x) { return x; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, props.apiService.sendUserInvites(emails)];
                case 2:
                    _a.sent();
                    props.onboardingTelemetryService
                        .onboardingStepCompleted(event_tracker_types_1.OnboardingStepName.InviteUsers, {
                        usersInvited: emails.length,
                    })
                        .catch(function () { return ({}); });
                    props.onComplete();
                    return [3, 4];
                case 3:
                    e_1 = _a.sent();
                    if (e_1 && typeof e_1 === "object" && (0, Utils_1.hasOwnProperty)(e_1, "message") && typeof e_1.message === "string") {
                        return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)(e_1.message)];
                    }
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var skip = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            props.onboardingTelemetryService
                .onboardingStepCompleted(event_tracker_types_1.OnboardingStepName.InviteUsers, {
                usersInvited: 0,
            })
                .catch(function () { return ({}); });
            props.onComplete();
            return [2];
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(CensusCollector_1.className, "__invite-team")) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(CensusCollector_1.className, "__header")) },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", strong: true, align: "center" }, "Add team members for free during trial"),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "l", align: "center" }, "Get more done with your team")),
            react_1.default.createElement(kaleidoscope_1.FormComponent, { className: c("form"), fieldSize: "large", onSubmit: submitForm },
                react_1.default.createElement(kaleidoscope_1.FormContext.Consumer, null, function (ctx) { return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(FormV2FieldTransition, { className: c("field") },
                        react_1.default.createElement("p", null, "Invite with email")),
                    INVITE_EMAIL_PLACEHOLDERS.map(function (addr, index) {
                        var fieldId = "".concat(EMAIL_FIELD_BASE_ID, "-").concat(index + 1);
                        return (react_1.default.createElement(FormV2FieldTransition, { className: c("field"), key: fieldId },
                            react_1.default.createElement(kaleidoscope_1.FormTextInput, { name: fieldId, type: kaleidoscope_1.TextInputType.Email, label: "Invite with email", labelHidden: true, placeholder: addr, startElement: react_1.default.createElement(icons_1.User, null), onChange: function (value) {
                                    var _a;
                                    return onFieldChange(__assign(__assign({}, ((ctx === null || ctx === void 0 ? void 0 : ctx.values) || {})), (_a = {}, _a[fieldId] = value, _a)));
                                }, initialValue: props.dataStore.getById(fieldId) })));
                    }),
                    react_1.default.createElement(FormV2FieldTransition, { className: c("button-wrapper") },
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(kaleidoscope_1.Expandable, { onEnter: utils_1.forceReflow, expanded: !!(ctx === null || ctx === void 0 ? void 0 : ctx.submitError) }, function (_a) {
                                var expandableElementRef = _a.expandableElementRef;
                                return (react_1.default.createElement("div", { ref: expandableElementRef },
                                    react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Error", alertType: kaleidoscope_1.AlertType.Error }, ctx === null || ctx === void 0 ? void 0 : ctx.submitError)));
                            }),
                            react_1.default.createElement(kaleidoscope_1.FormSubmitButton, { className: c("button") },
                                react_1.default.createElement("span", null, buttonText)),
                            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Medium, className: c("skip-button"), onClick: function (event) {
                                    event.preventDefault();
                                    skip();
                                } },
                                react_1.default.createElement("span", null, "Do it later")))))); })))));
};
exports.InviteTeam = InviteTeam;
